import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Modal from '../shared/Modal.svelte';
import SegmentedControl from '../shared/SegmentedControl.svelte';
import BreastPicker from './BreastPicker.svelte';
import VolumePicker from './VolumePicker.svelte';
import Button from '../shared/Button.svelte';
import DatePicker from '../shared/DatePicker.svelte';
import { saveSession } from '../../lib/services/session';
import { getActiveChild } from '../../lib/stores/children.svelte.ts';
import { showToast } from '../shared/Toast.svelte';

var root_2 = $.from_html(`<div class="field svelte-12aquprm0fkj5"><label class="svelte-12aquprm0fkj5">Duration (minutes)</label> <input type="number" min="1" max="120" class="svelte-12aquprm0fkj5"/></div> <!>`, 1);
var root_4 = $.from_html(`<div class="field svelte-12aquprm0fkj5"><label class="svelte-12aquprm0fkj5">Duration (minutes)</label> <input type="number" min="1" max="120" class="svelte-12aquprm0fkj5"/></div>`);
var root_3 = $.from_html(`<!> <!> <!>`, 1);
var root_1 = $.from_html(`<div class="quick-log svelte-12aquprm0fkj5"><!> <div class="field-row svelte-12aquprm0fkj5"><div class="field svelte-12aquprm0fkj5"><label class="svelte-12aquprm0fkj5">Date</label> <!></div> <div class="field svelte-12aquprm0fkj5"><label class="svelte-12aquprm0fkj5">Time</label> <input type="time" class="svelte-12aquprm0fkj5"/></div></div> <!> <!></div>`);

function QuickLog($$anchor, $$props) {
	$.push($$props, true);

	let type = $.state('nursing');
	let date = $.state($.proxy(new Date().toISOString().split('T')[0]));
	let time = $.state($.proxy(new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })));
	let durationMin = $.state(15);

	// Reset date/time to current values each time the modal opens
	$.user_effect(() => {
		if ($$props.open) {
			$.set(date, new Date().toISOString().split('T')[0], true);
			$.set(time, new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }), true);
		}
	});

	let side = $.state(null);
	let volume = $.state(60);
	let source = $.state('fresh');

	const typeOptions = [
		{ value: 'nursing', label: 'Nurse' },
		{ value: 'pumping', label: 'Pump' },
		{ value: 'bottle', label: 'Bottle' }
	];

	const sourceOptions = [
		{ value: 'fresh', label: 'Fresh' },
		{ value: 'fridge', label: 'Fridge' },
		{ value: 'freezer', label: 'Freezer' },
		{ value: 'formula', label: 'Formula' }
	];

	async function handleSave() {
		const activeChild = getActiveChild();

		if (!activeChild) {
			showToast('No active child selected.', 'error');

			return;
		}

		try {
			const startTime = new Date(`${$.get(date)}T${$.get(time)}`).getTime();
			const durationMs = $.get(durationMin) * 60 * 1000;

			await saveSession(activeChild.id, {
				type: $.get(type),
				startTime,
				endTime: startTime + durationMs,
				durationMs,
				side: $.get(type) === 'nursing' ? $.get(side) || undefined : undefined,
				volumeMl: $.get(type) !== 'nursing' ? $.get(volume) : undefined,
				source: $.get(type) === 'bottle' ? $.get(source) : undefined
			});

			$$props.onsaved?.();
			$$props.onclose();
		} catch(e) {
			showToast('Failed to save session. Please try again.', 'error');
		}
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	Modal(node, {
		get open() {
			return $$props.open;
		},

		get onclose() {
			return $$props.onclose;
		},
		title: 'Quick Log',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var node_1 = $.child(div);

			SegmentedControl(node_1, {
				get options() {
					return typeOptions;
				},

				get selected() {
					return $.get(type);
				},
				onchange: (v) => $.set(type, v, true)
			});

			var div_1 = $.sibling(node_1, 2);
			var div_2 = $.child(div_1);
			var node_2 = $.sibling($.child(div_2), 2);

			DatePicker(node_2, {
				get value() {
					return $.get(date);
				},
				onchange: (v) => $.set(date, v, true)
			});

			$.reset(div_2);

			var div_3 = $.sibling(div_2, 2);
			var input = $.sibling($.child(div_3), 2);

			$.remove_input_defaults(input);
			$.reset(div_3);
			$.reset(div_1);

			var node_3 = $.sibling(div_1, 2);

			{
				var consequent = ($$anchor) => {
					var fragment_1 = root_2();
					var div_4 = $.first_child(fragment_1);
					var input_1 = $.sibling($.child(div_4), 2);

					$.remove_input_defaults(input_1);
					$.reset(div_4);

					var node_4 = $.sibling(div_4, 2);

					BreastPicker(node_4, {
						get selected() {
							return $.get(side);
						},
						onselect: (s) => $.set(side, s, true)
					});

					$.bind_value(input_1, () => $.get(durationMin), ($$value) => $.set(durationMin, $$value));
					$.append($$anchor, fragment_1);
				};

				var alternate = ($$anchor) => {
					var fragment_2 = root_3();
					var node_5 = $.first_child(fragment_2);

					{
						var consequent_1 = ($$anchor) => {
							var div_5 = root_4();
							var input_2 = $.sibling($.child(div_5), 2);

							$.remove_input_defaults(input_2);
							$.reset(div_5);
							$.bind_value(input_2, () => $.get(durationMin), ($$value) => $.set(durationMin, $$value));
							$.append($$anchor, div_5);
						};

						$.if(node_5, ($$render) => {
							if ($.get(type) === 'pumping') $$render(consequent_1);
						});
					}

					var node_6 = $.sibling(node_5, 2);

					VolumePicker(node_6, {
						get value() {
							return $.get(volume);
						},
						onchange: (v) => $.set(volume, v, true)
					});

					var node_7 = $.sibling(node_6, 2);

					{
						var consequent_2 = ($$anchor) => {
							var fragment_3 = $.comment();
							var node_8 = $.first_child(fragment_3);

							SegmentedControl(node_8, {
								get options() {
									return sourceOptions;
								},

								get selected() {
									return $.get(source);
								},
								onchange: (v) => $.set(source, v, true)
							});

							$.append($$anchor, fragment_3);
						};

						$.if(node_7, ($$render) => {
							if ($.get(type) === 'bottle') $$render(consequent_2);
						});
					}

					$.append($$anchor, fragment_2);
				};

				$.if(node_3, ($$render) => {
					if ($.get(type) === 'nursing') $$render(consequent); else $$render(alternate, -1);
				});
			}

			var node_9 = $.sibling(node_3, 2);

			Button(node_9, {
				variant: 'primary',
				fullWidth: true,
				onclick: handleSave,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text = $.text('Save');

					$.append($$anchor, text);
				},
				$$slots: { default: true }
			});

			$.reset(div);
			$.bind_value(input, () => $.get(time), ($$value) => $.set(time, $$value));
			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	QuickLog = $.hmr(QuickLog);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-12aquprm0fkj5');
		QuickLog[$.HMR].update(module.default);
	});
}

export default QuickLog;
import "bun-svelte:QuickLog.svelte-3arq6i7ibvsy3-style.css";